import { Config } from '@comall-backend-builder/core/lib/parser'; //
export let config: Config = {
    entities: {
        shippingOrder: {
            apiPath: '/shippingOrderNew',
            properties: {
                channelName: {
                    type: 'string',
                    displayName: '订单渠道',
                },
                shopName: {
                    type: 'string',
                    displayName: '下单来源',
                },
                deliveryStatusStr: {
                    type: 'string',
                    displayName: '发货状态',
                },
                expressNumber: {
                    type: 'string',
                    displayName: '快递单号',
                },
                orderType: {
                    type: 'string',
                    displayName: '订单类型',
                },
                orderNo: {
                    type: 'string',
                    displayName: '订单编号',
                },
                receiverName: {
                    type: 'string',
                    displayName: '收货人姓名',
                },
                sknCode: {
                    type: 'number.row',
                    displayName: 'SKN',
                },
                skuCode: {
                    type: 'number.row',
                    displayName: 'SKU',
                },
                quantity: {
                    type: 'string',
                    displayName: '数量',
                },
                productName: {
                    type: 'string',
                    displayName: '商品名称',
                },
                showName: {
                    type: 'string',
                    displayName: '展示名称',
                },
                sourceShop: {
                    type: 'string',
                    displayName: '货品所在仓库',
                },
                reservoirArea: {
                    type: 'string',
                    displayName: '货品所在库区',
                },
                remarkStatusStr: {
                    type: 'string',
                    displayName: '备注状态',
                },
                mobile: {
                    type: 'string',
                    displayName: '收货人手机号',
                },
                area: {
                    type: 'string',
                    displayName: '收货区域',
                },
                address: {
                    type: 'string',
                    displayName: '下单地址',
                },
                orderTimeStr: {
                    type: 'string',
                    displayName: '详细时间',
                },
            },
            filters: {
                channel_name: {
                    type: 'string.options.select',
                    displayName: '订单渠道',
                    controlConfig: {
                        placeholder: '订单渠道',
                    },
                    options: [
                        {
                            id: 'XHS',
                            name: '小红书',
                        },
                        {
                            id: 'TIAN_MAO',
                            name: '天猫',
                        },
                        {
                            id: 'APP',
                            name: 'APP应用',
                        },
                        {
                            id: 'MINI_PROGRAM',
                            name: '小程序',
                        },
                        {
                            id: 'PC',
                            name: '电脑端',
                        },
                        {
                            id: 'POS',
                            name: '线下',
                        },
                        {
                            id: 'WAP',
                            name: 'WAP站',
                        },
                        {
                            id: 'JD',
                            name: '京东订单',
                        },

                        {
                            id: 'PLUM',
                            name: 'PLUM订单',
                        },
                        {
                            id: 'VIDEO',
                            name: '视频直播',
                        },

                        {
                            id: 'TAO_BAO',
                            name: '淘宝',
                        },
                        {
                            id: 'BUSINESS',
                            name: '小B端',
                        },
                        {
                            id: 'BDS',
                            name: '包大师',
                        },
                        {
                            id: 'TURN',
                            name: '转转',
                        },
                    ],
                },
                sales_end: {
                    type: 'string.options.select',
                    displayName: '下单来源',
                    controlConfig: {
                        placeholder: '下单来源',
                    },
                    options: [
                        {
                            id: 'PZG',
                            name: '品真阁线上',
                        },
                        {
                            id: 'MUSEE',
                            name: '名见线上',
                        },
                        {
                            id: 'POS',
                            name: '线下POS',
                        },
                        {
                            id: 'BUSINESS',
                            name: '小B端',
                        },
                    ],
                },
                delivery_status: {
                    type: 'string.options.select',
                    displayName: '发货状态',
                    controlConfig: {
                        placeholder: '订单渠道',
                    },
                    options: [
                        {
                            id: '1',
                            name: '未发货',
                        },
                        {
                            id: '2',
                            name: '已发货',
                        },
                        {
                            id: '3',
                            name: '已取消',
                        },
                        {
                            id: '4',
                            name: '采购中',
                        },
                        {
                            id: '5',
                            name: '置换中',
                        },
                    ],
                },
                express_number: {
                    type: 'string',
                    displayName: '快递单号',
                    controlConfig: {
                        placeholder: '快递单号',
                    },
                },
                order_type: {
                    type: 'string.options.select',
                    displayName: '订单类型',
                    controlConfig: {
                        placeholder: '订单类型',
                    },
                    options: [
                        {
                            id: 'SALE',
                            name: '销售订单',
                        },
                        {
                            id: 'PRE_SALE',
                            name: '预售订单',
                        },
                        {
                            id: 'POINT',
                            name: '积分订单',
                        },
                        {
                            id: 'GIFT',
                            name: '赠品领用单',
                        },
                        {
                            id: 'YJHX',
                            name: '以旧换新订单',
                        },
                        {
                            id: 'RESERVE',
                            name: '客定订单',
                        },
                        {
                            id: 'ADVANCE_DEPOSIT',
                            name: '定金预售',
                        },
                        {
                            id: 'SPEED_CUSTOMIZATION',
                            name: '极速定制',
                        },
                        {
                            id: 'CUSTOMIZATION',
                            name: '定制订单',
                        },
                    ],
                },
                order_no: {
                    type: 'string',
                    displayName: '订单编号',
                    controlConfig: {
                        placeholder: '订单编号',
                    },
                },
                skn_code: {
                    type: 'string',
                    displayName: 'SKN',
                    controlConfig: {
                        placeholder: 'SKN',
                    },
                },
                sku_code: {
                    type: 'string',
                    displayName: 'SKU',
                    controlConfig: {
                        placeholder: 'SKU',
                    },
                },
            },
        },
    },
    components: {
        ShippingOrderView: {
            component: 'Card',
            title: '发货单管理',
            entity: 'shippingOrder',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'shippingOrderFilter',
                    },
                    {
                        component: 'ShippingOrder',
                    },
                ],
            },
        },

        shippingOrderFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'channel_name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sales_end',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'delivery_status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'express_number',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'order_type',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'order_no',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },

                {
                    property: 'skn_code',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },

                {
                    property: 'sku_code',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },
    },

    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    component: 'Viewport',
                    breadcrumbName: '交易管理',
                    childRoutes: [
                        {
                            path: '/shippingOrder',
                            component: 'ShippingOrderView',
                            breadcrumbName: '发货单管理',
                        },
                    ],
                },
            ],
        },
    ],
};
